import { GenericContentReference, Product } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import {
  ProductCard,
  ProductDetailsContext,
  ProductListComponent,
  ProductSection,
} from '@components';
import { t } from '@translations';
import { useContext } from 'react';
import { SwiperSlide } from 'swiper/react';

export const ProductAccessories = () => {
  const { product = {}, sections, onSectionEnter } = useContext(ProductDetailsContext);
  return sections?.accessories ? (
    <ProductSection
      sectionId='accessories'
      title={t(TextCodes.Product.Details.Accessories)}
      onSectionEnter={onSectionEnter}
    >
      <RelatedProducts products={product.accessories} />
    </ProductSection>
  ) : null;
};

export const SimilarProducts = () => {
  const { product = {}, sections, onSectionEnter } = useContext(ProductDetailsContext);
  return sections?.similar ? (
    <ProductSection
      sectionId='similar'
      title={t(TextCodes.Product.Details.SimilarProducts)}
      onSectionEnter={onSectionEnter}
    >
      <RelatedProducts products={product.relatedTo} />
    </ProductSection>
  ) : null;
};

export const UpsaleProducts = () => {
  const { product = {}, sections, onSectionEnter } = useContext(ProductDetailsContext);
  return sections?.upsale ? (
    <ProductSection
      sectionId='upsale'
      title={t(TextCodes.Product.Details.UpsaleProducts)}
      onSectionEnter={onSectionEnter}
    >
      <RelatedProducts products={product.upsale} />
    </ProductSection>
  ) : null;
};

export type RelatedProductProps = {
  products?: GenericContentReference<Product>[];
};

export const RelatedProducts = ({ products }: RelatedProductProps) => {
  return (
    <ProductListComponent>
      {products?.map((x) => {
        const item = x.expanded || {};
        return (
          <SwiperSlide key={item.code}>
            <ProductCard {...item} image={item.mainImage} />
          </SwiperSlide>
        );
      })}
    </ProductListComponent>
  );
};
